import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Shell, labelStyle, inputStyle, link, btn } from './ForgotPassword';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    setLoading(true);
    try {
      const r = await fetch('/api/auth/reset-password', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Reset failed.');
      setDone(true);
    } catch (err) {
      setError(err.message); setLoading(false);
    }
  };

  if (!token) {
    return (
      <Shell title="Reset password">
        <p style={{ fontSize: 14, color: 'var(--red)' }}>This reset link is missing its token.</p>
        <div style={{ marginTop: 20, textAlign: 'center' }}><Link to="/forgot-password" style={link}>Request a new link</Link></div>
      </Shell>
    );
  }

  return (
    <Shell title="Choose a new password">
      {done ? (
        <div>
          <p style={{ fontSize: 14, color: 'var(--gray-300)', lineHeight: 1.6 }}>Your password has been updated.</p>
          <div style={{ marginTop: 22, textAlign: 'center' }}><Link to="/login" style={link}>Sign in</Link></div>
        </div>
      ) : (
        <form onSubmit={submit}>
          <label style={labelStyle}>New password (8+ characters)</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" style={inputStyle}
            onFocus={e => Object.assign(e.target.style, { ...inputStyle, borderColor: 'var(--teal)' })} onBlur={e => Object.assign(e.target.style, inputStyle)} />
          {error && <div style={{ background: 'rgba(184, 84, 80,0.12)', border: '1px solid rgba(184, 84, 80,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--red)', marginBottom: 18 }}>{error}</div>}
          <button type="submit" disabled={loading} style={btn(loading)}>{loading ? 'Updating...' : 'Update password'}</button>
        </form>
      )}
    </Shell>
  );
}
